import React, { useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import "../../css/landing.css";
const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (<section>
    <main className="page-container landing-page-container">
      <Header />
      <section id="terms">
        <div className="container mt-3">
          <h1 className=" my-3 "><b>Terms of Services</b></h1>
          <p>
            The following terminology applies to these Terms and Conditions,
            Privacy Statement and all Agreements: "Client", "You" and "Your"
            refers to you, the person log on this website and compliant to the
            Company's terms and conditions. "The Company", "Ourselves", "We",
            "Our" and "Us", refers to our Company. "Party", "Parties", or "Us",
            refers to both the Client and ourselves. All terms refer to the offer,
            acceptance and consideration of payment necessary to undertake the
            process of our assistance to the Client in the most appropriate manner
            for the express purpose of meeting the Client's needs in respect of
            provision of the Company's stated services. Any use of the above
            terminology or other words in the singular, plural, capitalization
            and/or he/she or they, are taken as interchangeable and therefore as
            referring to same.
          </p>
        </div>
        <div className="container">
          <h2 className="mb-3"><b>Cookies</b></h2>
          <p>
            We employ the use of cookies. By accessing Upskillmeet, you agreed to use
            cookies in agreement with the Upskillmeet’s Privacy Policy.
          </p>
          <p>
            Most interactive websites use cookies to let us retrieve the user's
            details for each visit. Cookies are used by our website to enable the
            functionality of certain areas to make it easier for people visiting
            our website. Some of our affiliate/advertising partners may also use
            cookies.
          </p>
          <p><b>License</b></p>
          <p>You must not:</p>
          <ol>
            <li>Republish material from Upskillmeet</li>
            <li>Sell, rent or sub-license material from Upskillmeet</li>
            <li>Reproduce, duplicate or copy material from Upskillmeet</li>
            <li>Redistribute content from Upskillmeet</li>
          </ol>
          <p>This Agreement shall begin on the date hereof.</p>
          <p>
            Parts of this website offer an opportunity for users to post and
            exchange opinions and information in certain areas of the website.
            Upskillmeet does not filter, edit, publish or review Comments prior to their
            presence on the website. Comments do not reflect the views and
            opinions of Upskillmeet, its agents and/or affiliates. Comments reflect the
            views and opinions of the person who post their views and opinions. To
            the extent permitted by applicable laws, Upskillmeet shall not be liable for
            the Comments or for any liability, damages or expenses caused and/or
            suffered as a result of any use of and/or posting of and/or appearance
            of the Comments on this website.
          </p>
          <p>You warrant and represent that:</p>
          <ol>
            <li>
              You are entitled to post the Comments on our site and have all
              necessary licenses and consents to do so;
            </li>
            <li>
              The Comments do not invade any intellectual property right,
              including without limitation copyright, patent or trademark of any
              third party;
            </li>
            <li>
              The Comments do not contain any defamatory, libelous, offensive,
              indecent or otherwise unlawful material which is an invasion of
              privacy
            </li>
            <li>
              The Comments will not be used to solicit or promote business or
              custom or present commercial activities or unlawful activity.
            </li>
          </ol>
          <p>
            You hereby grant Upskillmeet a non-exclusive license to use, reproduce, edit
            and authorize others to use, reproduce and edit any of your Comments
            in any and all forms, formats or media.
          </p>

          <h2 className="mb-3"><b>Content Liability</b></h2>
          <p>
            We shall not be hold responsible for any content that appears on your
            Website. You agree to protect and defend us against all claims that is
            rising on your Website. No link(s) should appear on any Website that
            may be interpreted as libelous, obscene or criminal, or which
            infringes, otherwise violates, or advocates the infringement or other
            violation of, any third party rights.
          </p>
          <p><b>Reservation of Rights</b></p>
          <p>
            We reserve the right to request that you remove all links or any
            particular link to our Website. You approve to immediately remove all
            links to our Website upon request. We also reserve the right to amen
            these terms and conditions and it's linking policy at any time. By
            continuously linking to our Website, you agree to be bound to and
            follow these linking terms and conditions.
          </p>
          <h5 className="mb-3"><b>Removal of links from our website</b></h5>
          <p>
            If you find any link on our Website that is offensive for any reason,
            you are free to contact and inform us any moment. We will consider
            requests to remove links but we are not obligated to or so or to
            respond to you directly.
          </p>
          <p>
            We do not ensure that the information on this website is correct, we
            do not warrant its completeness or accuracy; nor do we promise to
            ensure that the website remains available or that the material on the
            website is kept up to date.
          </p>
          <h5 className="mb-3"><b>Disclaimer</b></h5>
          <p>
            To the maximum extent permitted by applicable law, we exclude all
            representations, warranties and conditions relating to our website and
            the use of this website. Nothing in this disclaimer will:
          </p>
          <ol>
            <li>
              limit or exclude our or your liability for death or personal injury;
            </li>
            <li>
              limit or exclude our or your liability for fraud or fraudulent
              misrepresentation;
            </li>
            <li>
              limit any of our or your liabilities in any way that is not
              permitted under applicable law; or
            </li>
            <li>
              Exclude any of our or your liabilities that may not be excluded
              under applicable law.
            </li>
          </ol>
          <p>
            The limitations and prohibitions of liability set in this Section and
            elsewhere in this disclaimer: (a) are subject to the preceding
            paragraph; and (b) govern all liabilities arising under the
            disclaimer, including liabilities arising in contract, in tort and for
            breach of statutory duty.
          </p>
          <p>
            As long as the website and the information and services on the website
            are provided free of charge, we will not be liable for any loss or
            damage of any nature.
          </p>
        </div>
      </section>
      <Footer />
    </main>
  </section>);
};

export default Terms;
